var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftVolumeAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2878_10335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 63
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 58",
    x: 0.100922,
    y: 0.545898,
    width: 83.0769,
    height: 61.6196,
    fill: "#6C7D8D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2878_10335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 289746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 289743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.1009 0.545898L68.6677 2.69389L71.625 6.68689C34.2714 36.9361 -9.45204 38.9142 -39.2457 37.7343L-39.3606 41.1804C-35.5896 41.3307 -31.4693 41.444 -27.0537 41.444C-15.4274 41.444 -1.76583 40.6483 12.9011 37.6012C36.0183 32.7978 56.4329 23.3018 73.6108 9.36942L76.5861 13.3871L81.1009 0.545898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.6175 62.1652V27.9624C45.2846 29.0832 42.9291 30.1276 40.5624 31.1006V62.1677H47.6175V62.1652Z",
    fill: "#7FF0A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.9995 62.1649V32.1226C35.6576 33.0315 33.3044 33.874 30.9444 34.6524V62.1649H37.9995Z",
    fill: "#57D27F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.6522 62.1652V22.5874C55.3283 23.9718 52.9729 25.2699 50.5971 26.4843V62.1652H57.6522Z",
    fill: "#7FF0A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.9648 62.1652V35.6011C25.6161 36.3228 23.2629 36.9805 20.9097 37.584V62.1652H27.9648Z",
    fill: "#57D27F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M67.6872 62.1653V15.9268C65.3746 17.6363 63.0191 19.2448 60.6321 20.7573V62.1653H67.6872Z",
    fill: "#A6FFC3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.9298 62.165V38.3179C15.5743 38.8746 13.2211 39.3746 10.8747 39.8254V62.165H17.9298Z",
    fill: "#37B460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.89276 62.1653V40.3701C5.53055 40.7815 3.17509 41.1411 0.837677 41.4564V62.1653H7.89276Z",
    fill: "#37B460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M76.9738 16.0624L73.4846 11.3525C72.5515 12.1359 71.6138 12.9044 70.6648 13.6533V62.1679H77.7199V13.9341L76.9716 16.0624H76.9738Z",
    fill: "#A6FFC3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftVolumeAirdrop);
export default __webpack_public_path__ + "static/media/nft-volume-airdrop.32d66cb4b92fea8a4f698cce15abddbe.svg";
export { ForwardRef as ReactComponent };